import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  closeButton: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 1,
  },
  header: {
    marginTop: 30,
    marginBottom: 20,
    flexDirection: 'row',
  },
  headerText: {
    paddingLeft: 16,
    justifyContent: 'center',
  },
  footer: {
    marginVertical: 20,
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerButtons: {
    paddingTop: 20,
    marginBottom: 0,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    alignItems: 'center',
  },
  footerButtonPaddingIos: {
    paddingBottom: 20,
  },
  footerButtonPaddingAndroid: {
    paddingBottom: 16,
  },
});
